<template lang="pug">
  v-list
    v-list-item(
      v-for="({ phoneNumber, id, remove, accept }) in phoneNumbers"
      :key="id")
      v-list-item-content {{ phoneNumber }}
      v-list-item-action(v-if="accept")
        v-btn(
          @click="accept"
          color="primary"
          icon)
          v-icon {{ mdiCheck }}
      v-list-item-action
        v-btn(
          @click="remove"
          icon)
          v-icon {{ accept ? mdiClose : mdiDelete }}
</template>

<script>
import { reactive, toRefs, computed } from '@vue/composition-api'
import { mdiDelete, mdiCheck, mdiClose } from '@mdi/js'
import data from '@iez/lib/data/'
import { page } from '@iez/core'

export default {
  setup () {
    const state = reactive({
      associations: data.get({
        root: 'associations',
        fields: [
          'id',
          'phoneNumber'
        ]
      }),
      requests: data.get({
        root: 'requestsToBecomeAssociation',
        fields: [
          'id', {
            user: [
              'id',
              'phoneNumber'
            ]
          }
        ]
      }),

      phoneNumbers: computed(
        () => [
          ...(state.requests ?? []).map(request => ({
            id: request.id,
            userId: request.user.id,
            phoneNumber: request.user.phoneNumber
          })).map(item => ({
            ...item,
            remove: () => {
              page.confirm({
                title: `Es-tu sûr de vouloir supprimer cette demande ?`,
                callback: () => {
                  data.remove({
                    root: 'requestsToBecomeAssociation',
                    ids: item.id,
                    parents: []
                  })
                }
              })
            },
            accept: () => {
              page.confirm({
                title: `Es-tu sûr de vouloir accepter cette demande ?`,
                callback: () => {
                  data.set({
                    root: 'associations',
                    items: [{
                      phoneNumber: item.phoneNumber
                    }],
                    fields: [
                      'id',
                      'phoneNumber'
                    ],
                  })
                  data.remove({
                    root: 'requestsToBecomeAssociation',
                    ids: item.id,
                    parents: []
                  })
                }
              })
            }
          })),
          ...(state.associations ?? []).map(
            association => ({
              ...association,
              remove: () => {
                page.confirm({
                  title: `Es-tu sûr de vouloir supprimer cette asso ?`,
                  callback: () => {
                    data.remove({
                      root: 'associations',
                      ids: association.id,
                      parents: [{
                        name: 'Query'
                      }]
                    })
                  }
                })
              }
            })
          )
        ]
      )
    })

    return {
      ...toRefs(state),
      mdiDelete,
      mdiCheck,
      mdiClose
    }
  }
}
</script>
